export type DataLayerEvent = {
  event: string
  [key: string]: unknown
}

export function pushDataLayerEvent(payload: DataLayerEvent) {
  if (typeof window === "undefined") {
    return
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(payload)
}

export const ADS_CONVERSION_EVENT = "GOOGLE_ADS_CONVERSION"
export const CTA_CLICK_EVENT = "cta_click"

export function reportAdsConversion(conversionLabel: string) {
  pushDataLayerEvent({
    event: ADS_CONVERSION_EVENT,
    conversion_id: GOOGLE_ADS_CONVERSION_ID,
    conversion_label: conversionLabel
  })
}

export function reportGAEvent(ctaName: string, eventCategory?: string) {
  pushDataLayerEvent({
    event: CTA_CLICK_EVENT,
    cta_name: ctaName,
    ...(eventCategory && { event_category: eventCategory })
  })
}

export const GOOGLE_TAG_MANAGER_ID = "GTM-5V42J6DW"
export const GOOGLE_ADS_CONVERSION_ID = "17742081509"
export const AD_CONVERSION_LABELS = {
  SUBMIT_LEAD_FORM: "4uTjCMiun-IbEOXbioxC",
  PHONE_CALL_LEAD: "YwNgCNbhoeIbEOXbioxC",
  BOOK_APPOINTMENT: "iWS8CNCUouIbEOXbioxC"
}

export const GA_EVENT_NAMES = {
  GO_TO_PATIENT_INQUIRY: "go_to_patient_inquiry",
  SCHEDULE_ZOOM_MEETING: "schedule_zoom_meeting"
}

declare global {
  interface Window {
    dataLayer?: DataLayerEvent[]
  }
}
